/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { ValidationRule } from '../../ValidationRule';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { OasHeader } from '../../../../openapi/models/OasHeader';
import { Oas30Header } from '../../../../openapi/v3/models/Oas30Header';
import { Oas30HeaderDefinition } from '../../../../openapi/v3/models/Oas30HeaderDefinition';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends ValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasHeaderExamplesMutualExclusivityRule extends ValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    public visitHeader(node : OasHeader) {
        let header : Oas30Header = <Oas30Header>node;
        this.reportIf(this.hasValue(header.example) && /* size */(<number>header.getExamples().length) > 0, node, Constants.PROP_EXAMPLE, this.map.apply(this, ));
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitHeaderDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30HeaderDefinition)
     * @param {Oas30HeaderDefinition} node
     */
    public visitHeaderDefinition(node : Oas30HeaderDefinition) {
        this.visitHeader(node);
    }
}
OasHeaderExamplesMutualExclusivityRule["__class"] = "io.apicurio.datamodels.core.validation.rules.mutex.OasHeaderExamplesMutualExclusivityRule";
OasHeaderExamplesMutualExclusivityRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




